import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from '../AuthContext'
import { api } from '../api'

/**
 * Casquette (lentille client/producteur) — S45, sortie du contexte de
 * navigation : c'est un etat d'IDENTITE de la personne, pas un etat de
 * navigation. Les composants la lisent via `useCasquette()`.
 *
 * Persistance `sessionStorage` (symetrique de `manrina_isProducer`) : un
 * rechargement — ou une relance PWA — CONSERVE la casquette. Corrige au
 * passage le deep-link producteur : avant, un refresh cote producteur
 * repartait en casquette client (adresses producteur : ADR-068).
 *
 * Articulation avec l'URL (ADR-068) : les pages EXCLUSIVEMENT producteur
 * vivent sous /producteur (la ZoneProducteur d'App.jsx bascule la casquette a
 * l'entree — l'URL fait foi) ; les onglets PARTAGES (/account, /wallet...)
 * restent communs et leur contenu suit CETTE casquette d'etat.
 */

const CLE_MODE = 'manrina_hubMode'
const CasquetteCtx = createContext(null)

export function CasquetteProvider({ children }) {
  const { isAuthenticated, token } = useAuth()

  const [hubMode, setHubModeBrut] = useState(() => sessionStorage.getItem(CLE_MODE) || 'client')
  const setHubMode = (m) => {
    sessionStorage.setItem(CLE_MODE, m)
    setHubModeBrut(m)
  }

  const [isProducer, setIsProducer] = useState(() => !!sessionStorage.getItem('manrina_isProducer'))
  // S62 : la garde de l'espace producteur (App.jsx) doit savoir si la
  // verification a eu lieu — sinon un vrai producteur serait renvoye a
  // l'accueil le temps de la reponse. Vrai d'emblee si deja connu (session).
  const [producteurVerifie, setProducteurVerifie] = useState(() => !!sessionStorage.getItem('manrina_isProducer'))

  // Detecter si l'utilisateur est producteur (organisation validee uniquement)
  useEffect(() => {
    if (isAuthenticated && token) {
      api.producer.getMe()
        .then((org) => {
          if (org && org.status === 'VALIDE') {
            sessionStorage.setItem('manrina_isProducer', 'true')
            setIsProducer(true)
          }
        })
        .catch(() => {})
        .finally(() => setProducteurVerifie(true))
    }
  }, [isAuthenticated, token])

  // Reset a la deconnexion (y compris le marqueur producteur persiste —
  // avant S48 c'etait le wrapper handleLogout d'App qui le retirait)
  useEffect(() => {
    if (!isAuthenticated) {
      setIsProducer(false)
      sessionStorage.removeItem('manrina_isProducer')
      sessionStorage.removeItem(CLE_MODE)
      setHubModeBrut('client')
      setProducteurVerifie(false)
    }
  }, [isAuthenticated])

  return (
    <CasquetteCtx.Provider value={{ hubMode, setHubMode, isProducer, producteurVerifie }}>
      {children}
    </CasquetteCtx.Provider>
  )
}

export function useCasquette() {
  const v = useContext(CasquetteCtx)
  if (!v) throw new Error('useCasquette hors de CasquetteProvider')
  return v
}
